import { useState, useEffect } from 'react';

const useModals = (filterButton: Element | null, mapButton: Element | null) => {
  const [{ filterModalVisible, mapModalVisible }, setIsModalsOpen] = useState({
    filterModalVisible: false,
    mapModalVisible: false,
  });

  const toggleModal = (type: 'filter' | 'map') => {
    setIsModalsOpen((prev) => ({
      ...prev,
      [`${type}ModalVisible`]: !prev[`${type}ModalVisible`],
    }));
  };

  useEffect(() => {
    if (filterButton) {
      filterButton.addEventListener('click', () => toggleModal('filter'));
    }

    if (mapButton) {
      mapButton.addEventListener('click', () => toggleModal('map'));
    }

    return () => {
      if (filterButton) {
        filterButton.removeEventListener('click', () => toggleModal('filter'));
      }

      if (mapButton) {
        mapButton.removeEventListener('click', () => toggleModal('map'));
      }
    };
  }, [filterButton, mapButton]);

  return {
    filterModalVisible,
    mapModalVisible,
    toggleModal,
  };
};

export default useModals;
